// Libraries
import { useSession } from 'next-auth/react';
import { useEffect } from 'react';
// Types
import { Status } from '@globalTypes/index';
// Utils
import { getUserHomeUrl } from '@utils/helpers';

/**
 * Custom hook for redirect to home when the user authentication status is 'AUTHENTICATED'.
 */
export const useRedirectToHome = () => {
  const { status, data } = useSession();

  useEffect(() => {
    const isAuthenticated = status === Status.authenticated;
    const userAttributes = data?.user?.featureAttributes;
    const accessToken = data?.user?.accessToken;
    if (isAuthenticated && userAttributes && accessToken) {
      const userHomePath = getUserHomeUrl(userAttributes, accessToken);
      window.location.href = userHomePath;
    }
  }, [data?.user?.accessToken, data?.user?.featureAttributes, status]);
};
